module.exports = __webpack_public_path__ + "static/media/labeling-interface-annotated.7229b60a.png";